import { PosixDate, stringLiteralUnionField, uuidField, } from "@for-it/domain-lib";
import { NotFoundError } from "@for-it/domain-lib";
import { createValidationSchema, stringField } from "@for-it/domain-lib";
import { Permission } from "../../auth/permissions.js";
import { MaritalStatus } from "../../entities/applicant.js";
import { ApplicantEntity, applicantFilterSecureProperties, } from "../../entities/applicant.js";
import { UserEntity } from "../../entities/user.js";
import { ApplicantNotFoundError } from "../../errors/applicant-not-found.js";
export const editApplicantWorkData = {
    name: "editApplicantWorkData",
    description: "edit a existent applicant work data",
    isAuthRequired: true,
    requiredPermissions: [Permission.EDIT_APPLICANT_WORK_DATA],
    payloadSchema: createValidationSchema({
        linkedin: stringField({
            required: false,
            message: "Must be a string",
        }),
        gitHub: stringField({
            required: false,
            message: "Must be a string",
        }),
        ong: stringField({
            required: false,
            message: "Must be a string",
        }),
        identityNumber: stringField({
            required: false,
            message: "Must be a string",
        }),
        maritalStatus: stringLiteralUnionField({
            required: false,
            message: `Must be ${"MARRIED or SINGLE or DIVORCED or WIDOWED"}`,
            allowedValues: Object.values(MaritalStatus),
        }),
        nationality: stringField({
            required: false,
            message: "Must be a string",
        }),
        address: stringField({
            required: false,
            message: "Must be a string",
        }),
        provinceId: uuidField({
            required: false,
            message: "Must be a uuid",
        }),
        localityId: uuidField({
            required: false,
            message: "Must be a uuid",
        }),
    }),
    useCase: async ({ db, currentUser }, { linkedin, gitHub, ong, identityNumber, maritalStatus, nationality, address, provinceId, localityId, }) => {
        const user = await db.findOne(UserEntity, {
            where: { id: currentUser.id },
        });
        if (!user)
            return new NotFoundError();
        const applicant = await db.findOne(ApplicantEntity, {
            where: { userId: user.id },
        });
        if (!applicant)
            return new ApplicantNotFoundError();
        await db.update(ApplicantEntity, { id: applicant.id }, {
            linkedin: linkedin ?? applicant.linkedin,
            gitHub: gitHub ?? applicant.gitHub,
            ong: ong ?? applicant.ong,
            identityNumber: identityNumber ?? applicant.identityNumber,
            maritalStatus: maritalStatus ?? applicant.maritalStatus,
            nationality: nationality ?? applicant.nationality,
            address: address ?? applicant.address,
            provinceId: provinceId ?? applicant.provinceId,
            localityId: localityId ?? applicant.localityId,
            updatedAt: new PosixDate(Date.now()),
        });
        const updatedApplicant = await db.findOneOrFail(ApplicantEntity, {
            where: { userId: currentUser.id },
        });
        return applicantFilterSecureProperties(updatedApplicant);
    },
};
